import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type PWAInstallationPromptStoreState = {
  dismissed: boolean
  setDismissed: (dismissed: boolean) => void
}

export const usePWAInstallationPromptStore = create<PWAInstallationPromptStoreState>()(
  persist(
    set => ({
      dismissed: false,
      setDismissed: dismissed => set({ dismissed }),
    }),
    {
      name: 'pwaInstallationPrompt-storage',
      /**
       * NOTE: Ref. https://docs.pmnd.rs/zustand/integrations/persisting-store-data
       * By default persist uses localStorage, adding optional "storage" for clarity
       */
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
